import { type ReactNode, useState } from 'react'
import { cn } from '@/lib/utils'

export function Tooltip({
  label,
  children,
  side = 'bottom',
}: {
  label: string
  children: ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
}) {
  const [open, setOpen] = useState(false)
  const pos =
    side === 'top'    ? 'bottom-full mb-1 left-1/2 -translate-x-1/2'
  : side === 'bottom' ? 'top-full mt-1 left-1/2 -translate-x-1/2'
  : side === 'left'   ? 'right-full mr-1 top-1/2 -translate-y-1/2'
  :                     'left-full ml-1 top-1/2 -translate-y-1/2'
  return (
    <span className="relative inline-flex" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)}>
      {children}
      {open ? (
        <span
          role="tooltip"
          className={cn(
            'absolute z-40 px-2 py-1 rounded-md bg-heading text-white text-xs whitespace-nowrap shadow-elevated pointer-events-none',
            pos,
          )}
        >
          {label}
        </span>
      ) : null}
    </span>
  )
}
